import React, { useRef, useEffect } from 'react';

const ACTIONS = ['view', 'edit', 'delete'];

// Чекбокс заголовка секции: трёхпозиционный (все/часть/ничего). indeterminate —
// это DOM-свойство, не атрибут, поэтому выставляем через ref (Epic 8 фаза 3).
function SectionCheckbox({ checked, indeterminate, onChange, title }) {
    const ref = useRef(null);
    useEffect(() => { if (ref.current) ref.current.indeterminate = indeterminate; }, [indeterminate]);
    return (
        <input ref={ref} type="checkbox" checked={checked} onChange={onChange} title={title} />
    );
}

// Общая сетка чекбоксов «раздел × действие». Состояние ячейки отдаёт
// вызывающий через getCell(pageKey, action) -> { checked, marked },
// marked = ячейка отличается от базового значения (подсветка).
// onToggleSection(pageKeys, action, value) — включить/выключить всю колонку
// секции разом (может быть не передан — тогда групповых чекбоксов нет).
function PermissionsGrid({ pages, getCell, onToggle, onToggleSection }) {
    const sections = [];
    for (const p of pages) {
        const last = sections[sections.length - 1];
        if (!last || last.name !== p.section) sections.push({ name: p.section, items: [p] });
        else last.items.push(p);
    }

    return (
        <table className="admin-panel__table perm-grid">
            <thead>
                <tr>
                    <th>Section</th>
                    {ACTIONS.map(a => <th key={a} className="perm-grid__action">{a}</th>)}
                </tr>
            </thead>
            <tbody>
                {sections.map(s => {
                    const keys = s.items.map(p => p.page_key);
                    return (
                    <React.Fragment key={s.name}>
                        <tr className="perm-grid__section">
                            <td>{s.name}</td>
                            {ACTIONS.map(a => {
                                if (!onToggleSection) return <td key={a} className="perm-grid__cell" />;
                                const checkedCount = keys.filter(k => getCell(k, a).checked).length;
                                const allChecked = checkedCount === keys.length;
                                return (
                                    <td key={a} className="perm-grid__cell">
                                        <SectionCheckbox
                                            checked={allChecked}
                                            indeterminate={checkedCount > 0 && !allChecked}
                                            onChange={() => onToggleSection(keys, a, !allChecked)}
                                            title={`${allChecked ? 'Clear' : 'Grant'} "${a}" for the whole "${s.name}" section`}
                                        />
                                    </td>
                                );
                            })}
                        </tr>
                        {s.items.map(p => (
                            <tr key={p.page_key}>
                                <td>
                                    {p.title}
                                    {p.is_tech ? <span className="admin-panel__muted"> (tech)</span> : null}
                                </td>
                                {ACTIONS.map(a => {
                                    const cell = getCell(p.page_key, a);
                                    return (
                                        <td key={a} className={`perm-grid__cell${cell.marked ? ' is-marked' : ''}`}>
                                            <input
                                                type="checkbox"
                                                checked={!!cell.checked}
                                                onChange={() => onToggle(p.page_key, a)}
                                            />
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </React.Fragment>
                    );
                })}
            </tbody>
        </table>
    );
}

export default PermissionsGrid;
